module.exports = __webpack_public_path__ + "img/LUB00424.b9d3ff65.png";